import { Component } from "react";
import { RefreshCw, AlertTriangle } from "lucide-react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="min-h-screen flex flex-col items-center justify-center gap-4 bg-slate-950 text-center p-6"
          data-testid="error-boundary-fallback"
        >
          <AlertTriangle className="w-10 h-10 text-amber-500" />
          <h1 className="text-xl font-semibold text-slate-100">Something went wrong</h1>
          <p className="text-sm text-slate-400 max-w-sm">
            This page hit an unexpected error. Try reloading — your data is safe.
          </p>
          <button
            onClick={this.handleReload}
            data-testid="error-boundary-reload-btn"
            className="flex items-center gap-2 px-4 py-2 rounded-lg bg-slate-800 hover:bg-slate-700 text-slate-100 text-sm font-medium transition-colors"
          >
            <RefreshCw className="w-4 h-4" />
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
